"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var js_sha3_1 = require("js-sha3");

var buffer_1 = require("./buffer");

var constants_1 = require("./constants");

var hex_1 = require("./hex");

function keccak256() {
  return "".concat(constants_1.HEX_PREFIX).concat(js_sha3_1.keccak_256(buffer_1.toBuffer(hex_1.concatHex.apply(hex_1, arguments))));
}

exports.keccak256 = keccak256;